export const emailSettingsSelector = state => state.emailSettings